import { IdeyaButton } from '../../../../common/antd/ideya-button.tsx'
import { EditOutlined, EyeOutlined } from '@ant-design/icons'
import Row from 'antd/es/grid/row'
import Col from 'antd/es/grid/col'

interface IdeaActionColumnProps {
  data: { id: string; state: string; canEdit: boolean }
  onEditIdea: (id: string) => void
  onViewIdea: (id: string) => void
}

export const IdeaActionColumn: React.FC<IdeaActionColumnProps> = ({
  data,
  onEditIdea,
  onViewIdea,
}) => {
  if (!data) return <></>

  return (
    <Row gutter={[8, 0]}>
      <Col>
        <IdeyaButton
          icon={<EyeOutlined />}
          onClick={() => onViewIdea(data.id)}
        />
      </Col>
      {data.canEdit && (
        <Col>
          <IdeyaButton
            icon={<EditOutlined />}
            onClick={() => onEditIdea(data.id)}
          />
        </Col>
      )}
    </Row>
  )
}
